var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0FCEBB",
    d: "M39.75,35.048c0,2.597-2.105,4.702-4.702,4.702H4.952c-2.597,0-4.702-2.105-4.702-4.702V4.952 c0-2.597,2.105-4.702,4.702-4.702h30.096c2.597,0,4.702,2.105,4.702,4.702V35.048z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.27,19.605c-0.307,0.448-0.581,0.923-0.927,1.343c-1.864,2.265-4.043,4.154-6.676,5.482 c-1.782,0.9-3.663,1.473-5.657,1.662c-3.902,0.368-7.431-0.668-10.66-2.83c-2.083-1.393-3.821-3.146-5.333-5.132 c-0.119-0.156-0.191-0.349-0.284-0.525c0-0.154,0-0.308,0-0.461c0.306-0.449,0.583-0.923,0.926-1.342 c1.863-2.266,4.042-4.156,6.677-5.484c1.782-0.899,3.663-1.472,5.656-1.661c3.903-0.37,7.43,0.668,10.66,2.829 c2.084,1.393,3.822,3.147,5.333,5.132c0.12,0.157,0.191,0.351,0.285,0.526C34.27,19.297,34.27,19.452,34.27,19.605z M19.674,25.576 c3.379-0.058,6.101-2.942,6.034-6.394c-0.068-3.366-2.923-6.066-6.354-6.01c-3.415,0.056-6.124,2.914-6.059,6.392 C13.357,22.938,16.219,25.636,19.674,25.576z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.519,16.03c1.812-0.001,3.325,1.492,3.328,3.286c0.003,1.873-1.494,3.394-3.344,3.4 c-1.836,0.005-3.344-1.499-3.344-3.332C16.161,17.543,17.675,16.031,19.519,16.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon02);
export default __webpack_public_path__ + "static/media/view-icon-02.3af44eca50e3c764f0989b9e0b00987a.svg";
export { ForwardRef as ReactComponent };